import { useEffect, useState } from "react"
import { getCachedPageCount, resolvePageCount } from "@/lib/pdfPageCountCache"

export function usePdfPageCount(url: string | undefined): number | null {
  // A known count renders on the first paint, so returning to a chat no longer
  // flashes an empty badge while the file is parsed again.
  const [pageCount, setPageCount] = useState<number | null>(() =>
    url ? getCachedPageCount(url) : null,
  )

  useEffect(() => {
    if (!url) {
      setPageCount(null)
      return
    }

    const cached = getCachedPageCount(url)
    if (cached !== null) {
      setPageCount(cached)
      return
    }

    let cancelled = false

    void resolvePageCount(url).then((count) => {
      if (!cancelled) setPageCount(count)
    })

    return () => {
      cancelled = true
    }
  }, [url])

  return pageCount
}
